import createQueryHooks from 'openapi-react-query';
import { api } from './client';

/** TanStack Query-хуки поверх типизированного клиента: `$api.useQuery('get', '/api/v1/me')`. */
export const $api = createQueryHooks(api);
